export const SOUNDBOX_API_ENDPOINTS = {
  ADMIN_SIGN_IN: 'v1/auth/admin/email/login',
  ADMIN_OTP_SIGN_IN: 'v1/auth/admin/login',
  ADMIN_SIGN_OUT: 'v1/auth/logout',
  FORGET_PASSWORD: 'v1/auth/forgot-password',
  RESET_PASSWORD: 'v1/auth/reset-password',
  ADMIN_VALIDATE_LOGIN_OTP: 'v1/auth/admin/email/login/validateotp',
  DEVICE_LIST: 'v1/devices',
  GET_DEVICE_BY_ID: 'v1/devices/getDeviceDetails',
  GET_MERCHANT_LIST: 'v1/merchants',
  ADD_NEW_MERCHANT: 'v1/merchants',
  MERCHANT_BULK_UPLOAD: 'v1/merchant-vpa/upload',
  GET_ALL_BRANCH_AND_REGION: 'v1/merchants/getdistinctitem?item=',
  DEACTIVATE_MERCHANT: 'v1/merchants/deactivate',
  CREATE_ORGANIZATION: 'v1/organizations',
  GET_ORGANIZATION_LIST: 'v1/organizations',
  CREATE_USER_IN_ORGANIZATION: 'v1/users',
  USERS_BULK_UPLOAD: 'v1/users/bulk',
  ORG_BRANCHES_BULK_UPLOAD: 'v1/merchants-services-area',
  DASHBOARD_STATS: 'v1/devices/stats',
  TRANSACTION_STATS: 'v1/transactions/stats',
  TRANSATION_LIST: 'v1/transactions',
  GET_DEVICE_TRANSACTION: 'v1/transactions',
  DEVICE_LIST_WITH_TRANS: 'v1/devices/getDeviceList',

  DEVICE_REBOOT_REQUEST: 'v1/events/RequestByServer',

  NOTIFICATION_HISTORY: 'v1/device-inventories/getNotification',

  GET_DEVICE_HEARTBEAT: 'v1/heartbeats/devices',
  MERCHANT_STATUS_UPDATE: 'v1/merchants/statusUpdate',

  ACTIVATE_MERCHANT_BY_ASSIGN_DEVICE: 'v1/merchants/mapdevices',

  ORG_MERCHANT_STATS: 'v1/merchant-vpa/stats',
  MERCHANT_COMPLAINT_TICKETS: 'v2/search/tickets', // Change Later
  GET_ALL_TICKETS: 'v2/tickets', // Change Later

  DEVICE_LANGUAGE: 'v1/languages',
  UPDATE_DEVICE_LANGUAGE: 'v1/languages/updateDeviceLanguage',
  EXPORT_MERCHANT_REPORT: 'v1/merchants/analytics/export',
  MERCHANT_TCIKET: 'v2/tickets',
  EXPORT_DATA_URL: 'v1/reports',
  EXPORT_USERS_URL: 'v1/users',

  CREATE_ZONE: 'v1/hierarchy/zone-offices',
  CREATE_REGION: 'v1/hierarchy/regional-offices',
  CREATE_BRANCH: 'v1/branches',

  GET_ZONE_HEAD_OFFICES: 'v1/hierarchy/head-offices',
  GET_ZONES: 'v1/hierarchy/zone-offices',
  GET_REGIONS: 'v1/hierarchy/regional-offices',
  GET_ZONE_HEAD_OFFICES_SEARCH: 'v1/hierarchy/head-offices/list',
  GET_ZONES_SEARCH: 'v1/hierarchy/zone-offices/list',
  GET_REGIONS_SEARCH: 'v1/hierarchy/regional-offices/list',
  GET_BRANCHES_SEARCH: 'v1/branches/list',

  MERCHANT_APPROVAL: 'v1/merchant-approval',
  GET_BRANCH_FOR_NON_ADMIN: 'v1/taxonomies',
  CHECK_DUPLICATES_FOR_VERIFICATION: 'v1/merchant-approval/check-duplicate',
  MERCHANT_VPA: 'v1/merchant-vpa',
  MERCHANT_VPA_APPROVAL: 'v1/merchant-vpa/approval',
  MERCHANT_VPA_DUPLICATE_CHECK: 'v1/merchant-vpa/duplicate-check',
  HEARTBEAT_TREND: 'v1/heartbeats/',
  DEVICE_LIVE_STATUS: 'v1/devices/connection-status/',
  GET_TRANSACTION_TREND: 'v1/transactions/trend',
  VENDOR_URL: 'v1/vendors',
  VENDOR_LOT_URL: 'v1/vendors/lots',
  GET_SCHEME_LIST: 'v1/schemes',
  GET_ALL_CAMPAIGNS: 'v1/campaigns',

  GET_SIMS: 'v1/sim-inventory',
  GET_DATA_USAGE: 'v1/sim-inventory/data-usage',
  SCHEME_URL: 'v1/schemes',
  CAMPAIGN_GRAPH: 'v1/mqttcommandlogs/announcement-trend/',
  GET_ALL_DEVICES_POOL: 'v1/devicepool',
  DEVICE_BULK_UPLOAD: 'v1/devicepool/bulk-upload',
  FOTA_UPDATE: 'v1/devices/firmware-update',
  TASK_UPDATE: 'v1/device-tasks',
  GET_ALL_FILES: 'v1/devices/files',
  GET_FOTA_HISTORY: 'v1/mqttcommandlogs/response-entries',
  UNMAP_MERCHANT: 'v1/merchants/statusUpdate',
  MAP_MERCHANT_WITH_DEVICE: 'v1/merchants/mapdevices',
  PLAY_AUDIO: 'v1/devices/custom-announcement',
  APN_UPDATE: 'v1/devices/apn-update',
  CHANGE_PASSWORD: 'v1/auth/change/password',
  TICKET_MANAGEMENT: 'v1/ticket-management',

  DEVICE_INACTIVE_REPORTS: 'v1/devices/inactive/export',
  MERCHANT_INACTIVE_REPORTS: 'v1/merchant-vpa/activity-status',

  // HIERARCHY URLS
  UPDATE_REGION: (regionId) => `v1/hierarchy/regional-offices/${regionId}`,
  UPDATE_BRANCH: (branchId) => `v1/branches/${branchId}`
};

export const APP_CONSTANTS = {
  L_KEY_OF_USER_DATA: 'puad',
  L_KEY_OF_USER_IOT_CLIENT_ID: 'padiotc',
  L_KEY_OF_USER_LOGGEDIN_STATUS: 'isLoggedin',
  L_KEY_OF_USER_ADMIN_SSOTOKEN: 'sso-token',
  L_KEY_OF_USER_ADMIN_COGNIO_CRED: 'cgntCred',
  L_KEY_OF_P_DASHBOARD: 'P_DASHB',
  L_ORGANIZATION_IDENTIFIER: 'org',
  L_KEY_CHECKER_MAKER_REQUIRED: 'NO',
  L_KEY_OF_USER_ADMIN_OPS_TOKEN: 'ops-token',

  API_SUCCESS_ACTION: 'API_SUCCESS_ACTION',
  API_FAILURE_ACTION: 'API_FAILURE_ACTION',
  API_INPROGRESS_ACTION: 'API_INPROGRESS_ACTION',

  USER_ROLE_SUPER_ADMIN: 'superadmin',
  USER_ROLE_ADMIN: 'admin',
  USER_ROLE_CHECKER: 'checker',
  USER_ROLE_MAKER: 'maker',
  USER_ROLE_L1_SUPPORT: 'L1_SUPPORT',

  DEVICE_LANGUAGE_OPTIONS: {
    en: 'English',
    hi: 'Hindi',
    mr: 'Marathi',
    gj: 'Gujrati',
    bn: 'Bengali',
    pu: 'Punjabi'
  },

  MERCHANT_MAPPING_SUCCESSFULL: 'MERCHANT_MAPPING_SUCCESSFULL',
  MERCHANT_MAPPING_UNSUCCESSFULL: 'MERCHANT_MAPPING_UNSUCCESSFULL',

  MERCHANT_UPDATE_SUCCESSFULL: 'MERCHANT_UPDATE_SUCCESSFULL',
  MERCHANT_UPDATE_UNSUCCESSFULL: 'MERCHANT_UPDATE_UNSUCCESSFULL',

  REGION_UPDATE_SUCCESSFULL: 'REGION_UPDATE_SUCCESSFULL',
  REGION_UPDATE_UNSUCCESSFULL: 'REGION_UPDATE_UNSUCCESSFULL',

  BRANCH_UPDATE_SUCCESSFULL: 'BRANCH_UPDATE_SUCCESSFULL',
  BRANCH_UPDATE_UNSUCCESSFULL: 'BRANCH_UPDATE_UNSUCCESSFULL',

  NO_CHANGES: 'NO_CHANGES',

  BOM_CLIENT_IDENTIFIER: 'BOM',
  BOI_CLIENT_IDENTIFIER: 'BOI',
  CBI_CLIENT_IDENTIFIER: 'CBI',
  IOB_CLIENT_IDENTIFIER: 'IOB',
  UJN_CLIENT_IDENTIFIER: 'UJN',
  KAGB_CLIENT_IDENTIFIER: 'KAGB',
  NPST_CLIENT_IDENTIFIER: 'NPST',
  SBI_CLIENT_IDENTIFIER: 'SBI',
  COSMOS_CLIENT_IDENTIFIER: 'COSMOS',
  PRATAP_CLIENT_IDENTIFIER: 'PCB',
  RSB_CLIENT_IDENTIFIER: 'RSB',
  GBCB_CLIENT_IDENTIFIER: 'GBCB',
  HASTI_CLIENT_IDENTIFIER: 'HASTI',

  L_KEY_OF_COGNITO_TOKEN: 'cogtokl',

  TICKET_STATUS_CODES: {
    OPEN: '2',
    RESOLVED: '3',
    CLOSED: '4',
    PENDING: '5',
    ON_HOLD: '6',
    ESCALATED: '7'
  },

  TRANSACTION_EXPORT_REPORT: 'TRANSACTION_SUMMARY_REPORT',
  MERCHANT_ONBOARDING_EXPORT_REPORT: 'MERCHANT_ONBOARDING_EXPORT_REPORT',
  INACTIVE_MERCHANTS_REPORT: 'INACTIVE_MERCHANTS_REPORT',
  INACTIVE_DEVICES_REPORT: 'INACTIVE_DEVICES_REPORT',

  UAT_ORG_IDS: {
    CBI: 'b7551d5b-219c-4fd0-9a13-9b223775c05a',
    KAGB: 'c2700c47-dcb5-4941-831d-1ce782c5f758',
    IOB: '6be13598-96e5-4b1a-ab20-a5f22414dbc9',
    UJN: '25040803-bb7b-41c0-b556-1e116c126ac4',
    NPST: '615e996d-9bb2-45e5-a9a4-2f925f66b445',
    SBI: '7e4d8823-cc0e-4a87-843c-af250ab1e40d',
    PCB: '48ea848b-f2ee-44a9-81f6-8174b932bbf3',
    COSMOS: 'f7b53e47-cde5-49ff-a8d4-82149fc4bdfb',
    RSB: '3338fde7-0243-4a2d-8770-5da45691fc28',
    GBCB: '5f79f24d-433f-48f7-98cd-af257b2e3218',
  },

  PROD_ORG_IDS: {
    CBI: 'b7551d5b-219c-4fd0-9a13-9b223775c05a',
    IOB: 'a8252858-a607-48fe-ade7-70d25117cf5b',
    UJN: '078372c8-81e1-470c-a51a-41ab598acfa8',
    PCB: '47f75019-e7ed-4770-b5e1-fa0bcbde8656',
    COSMOS: 'fb11d797-dcdc-4df1-8c3b-36280222e487',
    RSB: 'dfcd412b-d014-4393-86aa-b92445559f30',
    GBCB: '585bc8c2-2ed4-4bf0-bf04-74120ea6d36d',
    HASTI: 'e7215fc6-16b9-4fa5-966c-b3f5b9b81d32'
  },
  SBI_SUPPORT_EMAIL: 'sbisupport@nox.live',

  CBI_SUPPORT_EMAIL: 'cbisupport@nox.live',
  CBI_SUPPORT_CALL: '9711611637'
};

export const indianStates = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
  'Andaman and Nicobar Islands',
  'Chandigarh',
  'Dadra and Nagar Haveli and Daman and Diu',
  'Delhi',
  'Jammu and Kashmir',
  'Ladakh',
  'Lakshadweep',
  'Puducherry'
];

export const passwordRules = [
  {
    label: 'Must be between 8 and 20 characters, no spaces',
    test: (val) => val.length >= 8 && val.length <= 20 && !/\s/.test(val)
  },
  {
    label: 'Must include a special character (!@#$%^&*)',
    test: (val) => /[!@#$%^&*]/.test(val)
  },
  {
    label: 'Must include at least 3 numbers',
    test: (val) => (val.match(/\d/g) || []).length >= 3
  }
];


export const DEVICE_TYPES = [
  { value: 'plain_qr', label: 'Plain QR' },
  { value: 'qr_with_standee', label: 'QR With Standee' },
  { value: 'static_qr_soundbox', label: 'Static QR Soundbox' },
  { value: 'dynamic_qr_soundbox', label: 'Dynamic QR Soundbox' },
  { value: 'tap_and_pay_soundbox', label: 'Tap And Pay Soundbox' },
  { value: 'static_qr_with_nfc_soundbox', label: 'Static QR With NFC Soundbox' },
  { value: 'pocket_soundbox', label: 'Pocket Soundbox' }
];

export const DEVICE_TYPES_CBI = [
  { value: 'static_qr_soundbox', label: 'Static QR Soundbox' },
  { value: 'dynamic_qr_soundbox', label: 'Dynamic QR Soundbox' }
];

export const DEVICE_KEYS_CBI = {
  STATIC: 'static_qr_soundbox',
  DYNAMIC: 'dynamic_qr_soundbox'
};

export const CBI_SUPPORT = {
  phone: '+91 97116 11637',
  phoneHref: 'tel:+919711611637',
  email: 'cbisupport@nox.live'
};

export const IOB_SUPPORT = {
  phone: '+91 93556 67705',
  phoneHref: 'tel:+919355667705',
  email: 'iobsupport@nox.live'
};

export const DEFAULT_SUPPORT_CONTACT = {
  phone: '+91-1800-419-5566',
  phoneHref: 'tel:+9118004195566',
  email: 'helpdesk@ippb.in'
};

export const USER_LEVEL_TYPES = {
  HO: 'HO',
  ZO: 'ZO',
  RO: 'RO',
  BO: 'BO'
}

export const ROLE_CONSTANTS = {
  ADMIN: 'admin',
  CHECKER: 'checker',
  MAKER: 'maker'
};

/** Banks that only support the Admin role (no Checker/Maker in user creation). */
export const ADMIN_ONLY_ROLE_ORGS = new Set([
  APP_CONSTANTS.KAGB_CLIENT_IDENTIFIER,
  // APP_CONSTANTS.IOB_CLIENT_IDENTIFIER,
  APP_CONSTANTS.COSMOS_CLIENT_IDENTIFIER,
  APP_CONSTANTS.PRATAP_CLIENT_IDENTIFIER,
  APP_CONSTANTS.RSB_CLIENT_IDENTIFIER
]);

export const ROLE_OPTIONS = [
  { label: 'Admin', value: ROLE_CONSTANTS.ADMIN },
  { label: 'Checker', value: ROLE_CONSTANTS.CHECKER },
  { label: 'Maker', value: ROLE_CONSTANTS.MAKER }
];

export const BULK_KEYS = ['successCount', 'failureCount'];

export const BRANCH_REQUIRED_ROLES = ['maker', 'checker'];

export const USER_BULK_SAMPLE_PATH = '/static/samples/user_bulk_upload_sample.xlsx';

export const EXPORT_DATA_TYPE = {
  TRANSACTION_EXPORT_REPORT: 'TRANSACTION_SUMMARY_REPORT',
  MERCHANT_ONBOARDING_REPORT: 'MERCHANT_ONBOARDING_REPORT',
  MERCHANT_TRANSACTION_HISTORY_REPORT: 'MERCHANT_TRANSACTION_HISTORY_REPORT'
};

export const MERCHANT_MORE_MENU_ACTIONS = {
  UPDATE_MERCHANT: 'update_merchant',
  MAP_MERCHANT: 'map_merchant',
  UNMAP_MERCHANT: 'un_map_merchant',
};